"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageViewer = exports.ImageViewerDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var content_1 = require("./content");
var responsive_image_1 = require("./responsive-image");
exports.ImageViewerDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var HeaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var DescriptionStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    color: ", ";\n    padding: ", ";\n  "], ["\n    color: ", ";\n    padding: ", ";\n  "])), theme_1.theme.COLOR('light'), theme_1.theme.UNIT(3))
});
var ImageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ImgStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    max-height: 80vh;\n  "], ["\n    max-height: 80vh;\n  "])))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.article(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Header: styled_components_1.default.header(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  Description: (0, styled_components_1.default)(content_1.Content)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), DescriptionStyles),
  Image: (0, styled_components_1.default)(responsive_image_1.ResponsiveImage)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ImageStyles),
  Img: styled_components_1.default.img(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ImgStyles)
};
var ImageViewer = function (props) {
  var className = props.className,
    image = props.image,
    children = props.children,
    title = props.title,
    controls = props.controls;
  var naturalAspectRatio = image.width && image.height && image.width / image.height;
  var aspectRatio = props.aspectRatio || naturalAspectRatio && {
    base: naturalAspectRatio
  } || {
    base: 16 / 9
  };
  return react_1.default.createElement(My.Container, {
    className: className
  }, react_1.default.createElement(My.Header, null, title, controls), react_1.default.createElement(My.Image, {
    aspectRatio: aspectRatio,
    image: react_1.default.createElement(My.Img, {
      src: image.url
    })
  }), children && react_1.default.createElement(My.Description, {
    tiny: true
  }, children));
};
exports.ImageViewer = ImageViewer;
exports.ImageViewer.defaultProps = exports.ImageViewerDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;